import { font, FontInterface, FontFamily, FontWeight } from './font'
import { media, MediaInterface } from './media'
import { breakpoints } from './breakpoints'
import { animations, AnimationsInterface } from './animations'
import { colors, ColorsInterface } from './colors'
import { sizes, SizesInterface } from './size'
import { GridInterface, grid } from './grid'

export interface ThemeInterface {
  controls: {
    height: number
  }
  breakpoints: {
    desktop: number
    tablet: number
  }
  formMaxWidth: number
  loginFormMaxWidth: number
  font: FontInterface
  fontFamily: typeof FontFamily
  media: MediaInterface
  colors: ColorsInterface
  fontWeight: typeof FontWeight
  sizes: SizesInterface
  grid: GridInterface
  animations: AnimationsInterface
}

export const theme: ThemeInterface = {
  controls: {
    height: sizes.scale(9),
  },
  breakpoints,
  formMaxWidth: 500,
  loginFormMaxWidth: 400,
  font,
  fontFamily: FontFamily,
  fontWeight: FontWeight,
  media,
  colors,
  sizes,
  grid,
  animations,
}



// WEBPACK FOOTER //
// ./src/utils/theme/theme.ts